/* @generated */
import classNames from "classnames";
import * as React from "react";
const PICTOGRAM_SIZE_UNIT = 64;
export const PictogramIcon = ({
  className,
  // `src` is aliased as `IconComponent` for usage in JSX
  src: IconComponent,
  ...rest
}) => {
  const cls = classNames("dig-PictogramIcon", className);
  const isPresentation = !rest["aria-label"] && !rest["aria-labelledby"];
  return /* @__PURE__ */ React.createElement(
    IconComponent,
    {
      className: cls,
      width: PICTOGRAM_SIZE_UNIT,
      height: PICTOGRAM_SIZE_UNIT,
      focusable: "false",
      role: isPresentation ? "presentation" : void 0,
      ...rest
    }
  );
};
PictogramIcon.displayName = "PictogramIcon";
